import MediaApi from '../api-js/media.api';

export default class MediaService {

    static getImage(mediaId) {
        return new Promise((resolve, reject) => {
            MediaApi.getImage(mediaId).then((response) => {
                return response.json();
            }).then((data) => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static searchMedia(searchObj) {
        return new Promise((resolve, reject) => {
            MediaApi.searchMedia(searchObj).then((response) => {
                return response.json();
            }).then((data) => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static crop({image, alias}) {
        const crop = image.umbracoFile.crops.filter(item => {
            return item.alias == alias
        })[0];
        let cropHeight = null;
        let cropFound = false;
        
    
        let output = image && image.umbracoFile ? image.umbracoFile.src : product.imageUrl;
        output += "?quality=80";
    
        if (crop) {
            cropHeight = crop.height;
            if (crop.coordinates) {
                output += "&crop=" + crop.coordinates.x1 + "," + crop.coordinates.y1 + "," + crop.coordinates.x2 + "," + crop.coordinates.y2;
                output += "&cropmode=percentage";
            } else if (image.umbracoFile.focalPoint) {
                output += "&anchor=center&mode=crop&center=" + image.umbracoFile.focalPoint.top + "," + image.umbracoFile.focalPoint.left;
            } else {
                output += "&anchor=center&mode=crop";
            }
            output += "&width=" + crop.width;
            output += "&height=" + cropHeight;
            
            cropFound = true;
        }
    
        if (image.umbracoFile.focalPoint && !cropFound) {
            output += "&anchor=center&mode=crop&center=" + image.umbracoFile.focalPoint.top + "," + image.umbracoFile.focalPoint.left;
            output += "&height=" + cropHeight;
        }

        return output;
    }
}